module.exports = __webpack_public_path__ + "static/media/Quit.8a308551.svg";